// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__6BO_d","fadein":"Image_fadein___T0um"};